var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.976 7.146a.5.5 0 0 0-.707 0L13.774 21.642l-8.84-8.84a.5.5 0 0 0-.707 0l-1.414 1.415a.5.5 0 0 0 0 .707l9.184 9.184a.412.412 0 0 0 .009.009l1.414 1.414a.5.5 0 0 0 .707 0L30.391 9.268a.5.5 0 0 0 0-.707l-1.415-1.415Z",
    fill: "#15C2E0"
  })));
};

export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOC45NzYzIDcuMTQ2NDVDMjguNzgxIDYuOTUxMTggMjguNDY0NCA2Ljk1MTE4IDI4LjI2OTIgNy4xNDY0NUwxMy43NzM2IDIxLjY0Mkw0LjkzNDI3IDEyLjgwMjdDNC43MzkwMSAxMi42MDc0IDQuNDIyNDMgMTIuNjA3NCA0LjIyNzE2IDEyLjgwMjdMMi44MTI5NSAxNC4yMTY5QzIuNjE3NjkgMTQuNDEyMiAyLjYxNzY5IDE0LjcyODggMi44MTI5NSAxNC45MjRMMTEuOTk2NSAyNC4xMDc1QzExLjk5OTUgMjQuMTEwNyAxMi4wMDI2IDI0LjExMzkgMTIuMDA1NyAyNC4xMTdMMTMuNDE5OSAyNS41MzEyQzEzLjYxNTIgMjUuNzI2NSAxMy45MzE4IDI1LjcyNjUgMTQuMTI3IDI1LjUzMTJMMzAuMzkwNSA5LjI2Nzc3QzMwLjU4NTcgOS4wNzI1IDMwLjU4NTcgOC43NTU5MiAzMC4zOTA1IDguNTYwNjZMMjguOTc2MyA3LjE0NjQ1WiIgZmlsbD0iIzE1QzJFMCIvPgo8L3N2Zz4K";